import { string } from 'prop-types';
import React from 'react';

import styles from './styles.module.scss';
import { getDeliveryImage } from './utils';

function DeliveryTypeImage({ deliveryType }) {
  const imgSrc = getDeliveryImage(deliveryType);
  return imgSrc ? <img src={imgSrc} className={styles.deliveryImg} /> : null;
}

DeliveryTypeImage.propTypes = {
  deliveryType: string.isRequired
};

export default DeliveryTypeImage;
